import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Layout from '../../../components/shared/Layout/Layout';
import Button from '../../../components/shared/Button/Button';
import {
  AuthContainer,
  AuthCard,
  AuthTitle,
  AuthSubtitle,
  AuthFooter,
  FormGroup,
  FormLabel,
  FormInput,
  ErrorMessage,
} from '../../../components/shared/Form/Form.styles';
import { peekSessionNotice, clearSessionNotice } from '../../../utils/sessionExpiry';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(() => peekSessionNotice('user'));
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { clearSessionNotice('user'); }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error || 'Error al iniciar sesión');
    }
    setLoading(false);
  };

  return (
    <Layout>
      <AuthContainer>
        <AuthCard>
          <AuthTitle>Iniciar sesión</AuthTitle>
          <AuthSubtitle>Bienvenido de vuelta a BokerHub</AuthSubtitle>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel>Email</FormLabel>
              <FormInput
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="tu@email.com"
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Contraseña</FormLabel>
              <FormInput
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Tu contraseña"
                required
              />
            </FormGroup>

            <Button type="submit" fullWidth disabled={loading}>
              {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
            </Button>
          </form>

          <AuthFooter>
            <p>¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link></p>
            <hr />
            <p>¿Eres una empresa? <Link to="/empresa/login">Portal empresarial</Link></p>
            <p>¿Quieres vender actividades como promotor? <Link to="/promotor/login">Acceso de promotores</Link></p>
          </AuthFooter>
        </AuthCard>
      </AuthContainer>
    </Layout>
  );
};

export default Login;
